import React from "react";
import Hero from "@/components/site/Hero";
import HeroSlider from "@/components/site/HeroSlider";
import Marquee from "@/components/site/Marquee";
import Collections from "@/components/site/Collections";
import Manifesto from "@/components/site/Manifesto";
import BusinessHours from "@/components/site/BusinessHours";
import { Stats, CTASection, FAQSection, AdSlot } from "@/components/site/HomeSections";

/**
 * HomePage — clean light industrial layout.
 * Order:
 *   Hero (headline + featured product)
 *   HeroSlider (auto image slider — image-only, no text overlays)
 *   Marquee
 *   Collections (image-only clickable cards, category info below image)
 *   Manifesto (why choose us)
 *   Stats
 *   BusinessHours + AdSense-ready slot side-by-side
 *   FAQ
 *   CTA
 */
export default function HomePage() {
  return (
    <>
      <Hero />
      <HeroSlider />
      <Marquee />
      <Collections />
      <Manifesto />
      <Stats />
      <section className="bg-white border-t border-slate-100">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="label-eyebrow mb-3">Visit our workshop</div>
            <h2 className="font-display font-medium text-slate-900 text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight mb-6">
              Open now?<br />Check before you visit.
            </h2>
            <p className="text-slate-600 leading-relaxed max-w-md">
              Live status of our Lingsugur workshop. Sundays can be irregular — please WhatsApp or call before visiting.
            </p>
          </div>
          <div className="lg:col-span-7">
            <BusinessHours />
          </div>
        </div>
      </section>
      <AdSlot id="adslot-home" />
      <FAQSection />
      <CTASection />
    </>
  );
}
